export default "__VITE_ASSET__BsCznkpx__"